// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zSeO","textarea":"styles_textarea__1fKQh"};